module.exports = __webpack_public_path__ + "static/media/insertion-points-static.30515ac8.png";